<template>
  <td><a @click="onClick">{{ formatInvoice(invoice) }}</a></td>
</template>

<script>
  import utils from '../../../../utils';

  export default {
    name: "TableInvoiceLabel",
    props: ['playerId', 'invoice'],
    methods: {
      formatInvoice(invoice) {
        return utils.formatInvoice(invoice);
      },
      onClick() {
        this.$router.push(`/club/invoice/${this.playerId}/transfers`);
      },
    },
  }
</script>

<style scoped>
  td {
    text-align: center;
  }

  a {
    text-decoration: none;
    color: #369;
    cursor: pointer;
  }

  a:hover {
    color: #2f98ff;
  }
</style>
